"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : FORM : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  form: {
    '&.processing-true': {
      '& .grid, .name-save-changes, .name-discard-changes, .name-cancel': {
        extend: _index.disable
      }
    },
    '&.editable-false': {
      '& .grid, .name-save-changes, .name-discard-changes, .name-cancel': {
        extend: _index.disable
      }
    },
    // grid
    '& .gridset': {
      '& .griditem': {
        marginBottom: (0, _index.pxToEm)(20),
        marginRight: (0, _index.pxToEm)(20),
        maxWidth: (0, _index.pxToEm)(310),
        width: '100%',
        '& .field': {
          maxWidth: (0, _index.pxToEm)(310),
          width: '100%'
        },
        '&:last-child': {
          marginRight: '0'
        }
      },
      '&.direction-vertical': {
        '& .griditem': {
          maxWidth: '100%',
          marginRight: '0',
          '& .field': {
            maxWidth: '100%'
          }
        }
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  form: {
    width: '100%',
    '& .gridset': {
      width: '100%',
      '& .griditem': {
        width: '100%',
        maxWidth: '100%',
        marginRight: '0',
        '& .field': {
          minWidth: '100%',
          width: '100%',
          maxWidth: '100%'
        }
      }
    }
  }
});

exports.default = _default;